var $0936d7347ef4da4c$exports = {};
$0936d7347ef4da4c$exports = {
    "dismiss": `Avvisa`
};


export {$0936d7347ef4da4c$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
